<script lang="ts" setup>
import DeliveryRouteFreightItem from "@/views/trips/edit/components/DeliveryRouteFreightItem.vue";
import type { TripRoute, TripRouteFreight, TripRouteStop } from "@/types/trip";
import { getEntityKey } from "@/utils/sameEntity";

const updatedStopFreights = defineModel<TripRouteFreight[]>({ required: true });

defineProps<{
  routeFreights: TripRouteFreight[];
  stop: TripRouteStop;
  routeStops: TripRouteStop[];
  route: TripRoute;
}>();

const emit = defineEmits<{
  (e: "open-stop-dialog", routeStop: TripRouteStop): void;
}>();
</script>

<template>
  <div class="bg-grey-lighten-5 pa-4 rounded-b freight-border">
    <div class="text-grey-darken-2 mb-4">Select route freight(s) to be delivered to this stop:</div>
    <delivery-route-freight-item
      v-for="routeFreight in routeFreights"
      :key="getEntityKey(routeFreight)"
      v-model="updatedStopFreights"
      :route="route"
      :route-freight="routeFreight"
      :route-stops="routeStops"
      :stop="stop"
      @open-stop-dialog="(freight) => emit('open-stop-dialog', freight)"
    />
  </div>
</template>
